import VideoCard from '@/pages/home/components/VideoCard';
import { videos } from '@/mocks/videos';
import { useNavigate } from 'react-router-dom';

interface VideoGridProps {
  title: string;
  subtitle?: string;
  filter?: string;
  limit?: number;
}

export default function VideoGrid({ title, subtitle, filter, limit }: VideoGridProps) {
  const navigate = useNavigate();

  let filtered = filter ? videos.filter((v) => v.category === filter) : videos;
  if (limit) filtered = filtered.slice(0, limit);

  const handleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1920px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              {title}
            </h2>
            {subtitle && (
              <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {filtered.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              category={video.category}
              image={video.image}
              duration={video.duration}
              rating={video.rating}
              tags={video.tags}
              updateTime={video.updateTime}
              featured={video.featured}
              onClick={handleClick}
            />
          ))}
        </div>
      </div>
    </section>
  );
}